exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table__row--txs .from-address-arrow a,.table__row--txs .from-address-arrow span{min-width:65%}.table__row--txsHome .from-address-arrow a,.table__row--txsHome .from-address-arrow span{min-width:95px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f11e80f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contents/shared/TableSlotTxHome.vue
// module id = 281
// module chunks = 0